import React, { useState, useEffect } from "react";
import Spanish from "./components/Spanish";
import English from "./components/English"
import French from "./components/French"
import image from "./images/face.jpg"
import rotate from "./images/rotate.png"
import { Typewriter } from 'react-simple-typewriter'


const buttons = "sm:text-xs 2xl:text-lg  m-5 p-5 hover:underline cursor-pointer hover:text-black hover:bg-greens font-semibold hover:border-4 border-green-400 rounded transition transform hover:-translate-y-1 motion-reduce:transition-none motion-reduce:transform-none"
const border = {borderColor: "#22ff59", borderRightColor: "#22ff59",borderLeftColor: "#f048f0",borderBottomColor: "#f048f0" }
console.log(window.innerWidth)

// Hook
function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

function App() {

const [state, setState] = useState(0)
const size = useWindowSize();
	const handleClick = (num) => {
		setState(num)
	}

  return (
<div>
    {size.width <= 639 ? 
      <div className="absolute inset-0 bg-black text-white w-full h-full "> 
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", }} class="mt-32">
        <img style={border} class="w-3/12 h-3/12 animate-bounce rounded-full border-4 p-4 cursor-pointer transition transform hover:-translate-y-1 motion-reduce:transition-none motion-reduce:transform-none " src={rotate} alt="rotate" />
        </div> 
      </div> 
      : 
      <div className="absolute inset-0 bg-black text-white w-full h-full ml-8 " >
        <div class="absolute w-2/12 h-2/12 sm:ml-6 ml-14 mt-28 sm:text-xs">
            <img class="sm:m-1 rounded-full border-4 cursor-pointer transition transform hover:-translate-y-1 motion-reduce:transition-none motion-reduce:transform-none " onClick={()=> handleClick(0)} style={border} src={image} alt="pic" />
            <div class="sm:m-1 2xl:mt-4 2xl:ml-12   "><p class="sm:text-xs 2xl:text-lg">Oh, don't mind me.</p><p class="sm:text-xs 2xl:text-lg"> Just watching...</p></div>
        </div>

            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", }}>
              <div class={buttons} onClick={()=> handleClick(2)}>english</div>	
              <div style={{borderLeft: "2px solid white", height: "40px", marginLeft: "20px", marginRight: "20px"}}></div> 
              <div class={buttons} onClick={()=> handleClick(1)}>español</div>	
              <div style={{borderLeft: "2px solid white", height: "40px", marginLeft: "20px", marginRight: "20px"}}></div> 
              <div class={buttons} onClick={()=> handleClick(3)}>français</div>	
						</div>
          { state === 0 ? 
					<div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }} class="sm:text-xs sm:mt-10 sm:ml-40 sm:w-7/12 2xl:ml-80 2xl:pl-8 2xl:text-lg 2xl:mt-40">
						
							<Typewriter 
            words={["Choose your language | Elija su idioma | Choisissez votre langue"]}
            loop={1}
            cursor
            cursorStyle='|'
            typeSpeed={50}
            deleteSpeed={50}
            delaySpeed={100}
          /></div> : null }
					{ state === 1 ? <Spanish /> : null }
					{ state === 2 ? <English /> : null }
					{ state === 3 ? <French /> : null }
    </div>
  }
    </div>);
}

export default App;
